







import VueOptions from '@utils/VueOptions'

settings = 
  name: 'PublishBar'
  vue:
    props: ['event', 'actions']

    computed:
      showPublish: ->
        @event.draft &&
        !@event.potential_unconfirmed &&
        !@event.potential_denied

export default VueOptions.vue settings
